import gql from "graphql-tag";

export default gql`
	mutation logout($refreshToken: String!) {
		signOut(refreshToken: $refreshToken)
	}
`;

export const readAuthResult = ({ data }) => data?.signOut;
